import React from "react";
import { connect } from "react-redux";
import VideoButtons from "./VideoButtons";
import PopupUsers from "../../users/PopupUsers";
import ParticipantsSection from "../ParticipantsSection/ParticipantsSection";

const VideoSection = (props) => {
  const { showPopUsers, showParticipant } = props;
  
  return (
    <div className="video_section_container">
      
      <VideoButtons />
      
      {/* Render popups at the video section level for proper positioning */}
      {showPopUsers && <PopupUsers />}
      {showParticipant && <ParticipantsSection />}
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    showPopUsers: state.showPopUsers || false,
    showParticipant: state.showParticipant || false,
  };
};

export default connect(mapStoreStateToProps)(VideoSection);